export default "__VITE_ASSET__CXNn707r__"